import RequiresAuth from '@website/components/auth/RequiresAuth';
import Statements from '@website/components/hosts/dashboard/statements/Statements';
import SeoMetaTags from '@website/components/seoMetaTags';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { Breadcrumb, Container } from 'react-bootstrap';

export default function StatementsPage() {
  const { query } = useRouter();
  const hostURL = query.hostURL as string;

  return (
    <>
      <SeoMetaTags
        title="Host statements"
        description="Monthly payout statements"
      />
      <RequiresAuth>
        <Container className="pt-3">
          <Breadcrumb className="py-3">
            <Link href={`/hosts/dashboard/${hostURL}`} passHref legacyBehavior>
              <Breadcrumb.Item href="">Host Dashboard</Breadcrumb.Item>
            </Link>
            <Breadcrumb.Item active>Transactional Statements</Breadcrumb.Item>
          </Breadcrumb>
          <Statements hostURL={hostURL} />
        </Container>
      </RequiresAuth>
    </>
  );
}
